export const calculateLPPrice = (lpSupply: number | null, liquidityUSD: (number | null)[]): number => {
  if (!lpSupply) {
    return 0;
  }
  return liquidityUSD.reduce<number>((sum, value) => sum + (value ?? 0), 0) / lpSupply;
};
